import { useContext } from 'react';
import { useEffect } from 'react';
import { MapContext } from '../../../context/MapContext';
import { bgLayers, householdLayers, poiLayers } from '../layer';
import "../Content.css";
import { poiStyle } from '../../../common/data/poiStyle';
import { poiList } from '../../../common/data/list';
import { AppContext } from '../../../context/AppContext';

export default function Map() {
  const { setBackdropOpen } = useContext(AppContext);
  const { map, setMap,
          setEmdBoundary,
          createMap, getPoi,
          featureClickCallBack
        } = useContext(MapContext);

  let selectPoiIcon = null;
  const poiPointerMove = (e, map) => {
    if(selectPoiIcon !== null) {
      selectPoiIcon.setStyle(undefined);
      selectPoiIcon = null;
    };
    map.forEachFeatureAtPixel(e.pixel, poiSelectedCallBack);
  };

  const poiSelectedCallBack = (selectFeature, layer) => {
    poiList.forEach((obj) => {
      if(layer.get('title') === obj.name) {
        const features = obj.layerName.getSource().getFeatures();
        for(let feature of features) {
          feature.setStyle(undefined);
        };
        selectPoiIcon = selectFeature;
        poiStyle.selectedPoi.getText().setText(`${selectFeature.values_.name}`);
        selectFeature.setStyle(poiStyle.selectedPoi);
      };
    });
    return true;
  };

	useEffect(() => {
    setBackdropOpen(true);
    if(!map) {
      const _map = createMap(
        'agglomerateMap',
        Object.keys(bgLayers).map((key) => bgLayers[key]),
        Object.keys(householdLayers).map((key) => householdLayers[key]),
        Object.keys(poiLayers).map((key) => poiLayers[key]),
      );
      setMap(_map);

      getPoi('');
      
      _map.on('pointermove', (e) => {
        poiPointerMove(e, _map);
      });
      _map.on('click', (e) => {
        featureClickCallBack({e, target_map: _map});
      });
      _map.on('moveend', function(e) {
        const currentZoomLevel = _map.getView().getZoom();
        if(currentZoomLevel > 11) {
          setEmdBoundary(true);
          householdLayers.bgEmdLayer.setVisible(true);
        } else {
          setEmdBoundary(false);
          householdLayers.bgEmdLayer.setVisible(false);
        };
      });
    };
    setBackdropOpen(false);
	}, []);

	return (
		<div className='mapArea' id='agglomerateMap'>
		</div>
	);
}